import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';

function TreeOrderPaymentWebSuccessful() {
  const { menu, toggleMobileMenu } = useAppLayout();
  
  


  return (
    <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
            <Header onMenuClick={(value) => toggleMobileMenu()} />
            <Sidebar />
        <ToastContainer />

        <div className='page-wrapper'>
          <div className='content container-fluid'>

          <div className="main-wrapper d-flex align-items-center justify-content-center vh-100">
      <div className="card shadow-lg text-center p-5" style={{ maxWidth: "500px", borderRadius: "20px" }}>
        
        {/* Success Icon */}
        <div className="mb-4">
         
        </div>

        {/* Title */}
        <h3 className="fw-bold text-success">Payment Successful 🎉</h3>

        {/* Message */}
        <p className="text-muted mt-3">
          Thank you for the order! Your order will be processed.  
          
        </p>

        
      </div>
    </div>

          </div>
        </div>
      </div>
    
  );
}

export default TreeOrderPaymentWebSuccessful;
